import { IconBase, type IconProps } from './iconBase';

import type { JSX } from 'react';

export const Learn = ({ type, ...rest }: IconProps): JSX.Element => (
  <IconBase viewBox='0 0 24 24' {...rest}>
    {type === 'stroke' ? (
      <>
        <path
          d='M19 13.03V2.717c0-1.026-.882-1.786-1.953-1.701h-.054c-1.89.154-4.761 1.068-6.363 2.025l-.153.094c-.261.154-.693.154-.954 0l-.225-.128c-1.602-.948-4.464-1.854-6.354-2C1.873.921 1 1.69 1 2.707v10.324c0 .82.702 1.59 1.566 1.692l.261.034c1.953.248 4.968 1.188 6.696 2.085l.036.017c.243.128.63.128.864 0 1.728-.906 4.752-1.854 6.714-2.102l.297-.034C18.298 14.62 19 13.85 19 13.03'
          stroke='currentColor'
          strokeWidth='1.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M10 3.538V17'
          stroke='currentColor'
          strokeWidth='1.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M6.175 6.23H4.15'
          stroke='currentColor'
          strokeWidth='1.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M6.85 8.922h-2.7'
          stroke='currentColor'
          strokeWidth='1.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </>
    ) : (
      <>
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M11.25 4.953C9.528 3.935 7.039 3.265 5.014 3.109 3.466 2.986 2.1 4.12 2.1 5.707v10.324c0 1.303 1.07 2.429 2.354 2.585l.256.033h.004c1.848.235 4.761 1.144 6.394 1.992l.012.006.017.008.022.01q.045.024.091.043zm-7 4.277A.75.75 0 0 1 5 8.48h2.025a.75.75 0 0 1 0 1.5H5a.75.75 0 0 1-.75-.75M5 11.173a.75.75 0 1 0 0 1.5h2.7a.75.75 0 0 0 0-1.5z'
          fill='currentColor'
        />
        <path
          d='M12.75 4.947v15.754q.049-.022.096-.048c1.632-.854 4.544-1.767 6.399-2.003l.292-.033h.003c1.288-.154 2.36-1.281 2.36-2.587V5.717c0-1.591-1.361-2.702-2.886-2.601h-.021l-.073.003c-1.813.148-4.41.93-6.17 1.83'
          fill='currentColor'
        />
      </>
    )}
  </IconBase>
);
